import { observable, computed, action, makeObservable/*, toJS*/ } from "mobx";
import { default as orderStore} from "stores/OrderStore"
import { expectTime } from "utils/Utils"
import { configure } from "mobx"

configure({ enforceActions: "never" }) 

class TimerStore {

    constructor() {
        makeObservable(this);
    }

    @observable 
    currentTime = new Date();

    @action 
    updateCurrentTime = () => {
      this.currentTime = new Date();
    };

    startTimer = () => {
        // 매 초마다 updateCurrentTime 함수 호출
        this.timerId = setInterval(this.updateCurrentTime, 1000);
    };
  
    stopTimer = () => {
        // 타이머 정리
        clearInterval(this.timerId);
    };

    minTimer = () => {
        // 분단위 업데이트
        this.timerId = setInterval(() => {
            orderStore.getOrderList.map(order => {
                order.time = expectTime(order.elapseTime)
            });
        }, (60 * 1000));
    };

}

export default new TimerStore();